import styled from "styled-components";

export const LoaderWrap = styled.div`

`;


export const CommonLoader = styled.span`
 &.loading {
    height: 0;
    width: 0;
    padding: 12px;
    border: 4px solid #ccc;
    border-right-color: #01606F;
    border-radius: 22px;
    -webkit-animation: rotate 1s infinite linear;
    position: absolute;
    left: 50%;
}

@-webkit-keyframes rotate {
  /* 100% keyframe for  clockwise. 
     use 0% instead for anticlockwise */
  100% {
    -webkit-transform: rotate(360deg);
  }
}
`;